<template>
  <div class="file-preview">
    <!--图片预览-->
    <div class="img-dialog" v-if="dialogvisibleview && (modelType == 1 || modelType == 2)" @click="onClickDialog">
      <i class="el-icon-close" @click="onClickDialog"></i>
      <img :src="fileUrl" alt="" @click.stop="">
    </div>
    <!--文本预览-->
    <div class="txt-dialog" v-if="dialogvisibleview && (modelType == 3 || modelType == 4)" @click="onClickDialog">
      <div class="txt" >
        <i class="el-icon-close" @click="onClickDialog"></i>
        <div class="txt-preview" v-html="textPreview" @click.stop=""></div>
      </div>
    </div>
    <!--音频预览-->
    <div class="audio-dialog" v-if="dialogvisibleview && (modelType == 5 || modelType == 6)" @click="onClickDialog">
      <div class="txt audio" >
        <i class="el-icon-close" @click="onClickDialog"></i>
        <!-- 音频波纹播放区 -->
        <audio-play-area :currentAudioUrl="fileUrl" @click.stop=""></audio-play-area>
      </div>
    </div>
  </div>
</template>

<script>
import { GetText } from '@/assets/js/mixin/mixinGetTextStr.js'

import AudioPlayArea from '@/components/pretrain/AudioPlayArea'

export default {
  name: 'FilePreview',
  components: { AudioPlayArea },
  mixins: [GetText],
  props: {
    modelType: {
      type: String,
      default: '1',
    },
    fileUrl: {
      type: String,
      default: '',
    },
    dialogvisibleview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台上传基地址
      textPreview: '',
    }
  },
  watch: {
    fileUrl(val) {
      if (val) {
        if (this.modelType == 3 || this.modelType == 4) {
          this.getTxtContent(val);
        }
      }
    },
    // 混入方法获取解析文本
    getTextStr(val) {
      if (val) {
        this.textPreview = val;
      }
    },
  },
  created() {
    // console.log(this.modelType)
  },
  methods: {
    onClickDialog() {
      this.$emit('onClickDialog')
    },
  },
}
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.file-preview {
  .img-dialog {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 97;
    padding: 130px 50px 50px;
    .el-icon-close {
      color: #fff;
      font-size: 26px;
      font-weight: 700;
      position: absolute;
      top: 100px;
      right: 20px;
      z-index: 10;
      cursor: pointer;
      &:hover{
        color: #000;
      }
    }
    img {
      max-width: 90%;
      max-height: 80%;
    }
  }

  .txt-dialog,
  .audio-dialog {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 97;
    .txt {
      color: #000;
      width: 800px;
      height: 50%;
      background: #fff;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      .el-icon-close {
        color: #ccc;
        font-size: 18px;
        font-weight: 700;
        position: absolute;
        top: 8px;
        right: 20px;
        cursor: pointer;
        &:hover{
          color: #000;
        }
      }
      .txt-preview {
        width: 100%;
        height: 100%;
        padding: 20px 30px;
        overflow: auto
      }
    }
  }
  .audio-dialog {
    .audio {
      height: 28%;
      .el-icon-close {
        font-size: 22px;
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 3;
      }
    }
  }
}
</style>
